/*
  Exit-Intent-Popup  (assets/exit-intent-popup.js)
  Logik für sections/exit-intent-popup.liquid. Einstellungen kommen als JSON aus data-config
  (Theme-Einstellungen > Exit-Intent-Popup).

  Auslöser
    Computer: Maus verlässt das Fenster nach oben (frühestens nach dDelay Sekunden), optional nach dTimer Sekunden.
    Handy/Tablet: nach mSek Sekunden und/oder mScroll Prozent Scrolltiefe (mMode), optional schnelles Hochscrollen.
  Regeln
    nicht nach erfolgreicher Anmeldung, nach dem Schließen erst wieder nach „tage“ Tagen, höchstens einmal pro
    Besuch, erst ab Seitenaufruf Nr. minSeiten, Seiten ausschließen (ohne) oder nur auf bestimmten Seiten (nur).
    Mit ?popup_test=1 in der Adresse erscheint es sofort, ohne Regeln (zum Testen).
  Anmeldung
    window.mdlKundeAnlegen (snippets/shopify-kunde-js.liquid): Shopify-Kunde mit Newsletter-Zustimmung und Tag.
    Verlangt Shopify die Spam-Abfrage, wird das Formular normal abgeschickt; die Seite kommt mit
    ?popup=angemeldet zurück und das Popup zeigt direkt die Erfolgsansicht.
*/
(function () {
  'use strict';

  var K = { zu: 'mdl_eip_geschlossen', an: 'mdl_eip_angemeldet', teaserWeg: 'mdl_eip_teaser_weg', variante: 'mdl_eip_variante' };
  var S = { gezeigt: 'mdl_eip_gezeigt', seiten: 'mdl_eip_seiten' };
  var MARKER = 'popup=angemeldet';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function lies(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function schreib(store, k, v) { try { window[store].setItem(k, String(v)); } catch (e) {} }

  function start() {
    var root = document.getElementById('mdlEip');
    if (!root || root.getAttribute('data-eip-bereit')) return;
    root.setAttribute('data-eip-bereit', '1');

    var C = {};
    try { C = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) {}

    var box = root.querySelector('.eip__box');
    var schrittForm = root.querySelector('.eip__schritt--form');
    var schrittOk = root.querySelector('.eip__schritt--ok');
    var form = root.querySelector('.eip__form');
    var feldMail = form.querySelector('[name="email"]');
    var feldName = form.querySelector('[name="vorname"]');
    var fehlerEl = form.querySelector('.eip__fehler');
    var knopf = form.querySelector('.eip__btn');
    var knopfText = knopf.textContent;
    var captchaZiel = root.querySelector('.eip__captcha');
    var teaser = document.getElementById('mdlEipTeaser');

    var offen = false, ausgeloest = false, letzterFokus = null;
    var test = /[?&]popup_test=1/.test(window.location.search);
    var istTouch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
    var formteil = root.querySelector('.eip__formteil');
    var janein = root.querySelector('.eip__janein');

    /* A/B-Test: jeder Besucher behält seine Variante (A oder B) */
    var variante = 'A';
    if (C.ab) {
      variante = lies('localStorage', K.variante);
      if (variante !== 'A' && variante !== 'B') { variante = Math.random() < 0.5 ? 'A' : 'B'; schreib('localStorage', K.variante, variante); }
      if (variante === 'B') {
        root.classList.add('eip--variante-b');
        if (root.querySelector('#mdlEipTitelB')) box.setAttribute('aria-labelledby', 'mdlEipTitelB');
      }
    }

    function track(name, params) {
      params = params || {};
      if (C.ab) params.Variante = variante;
      try { if (window.mdlTrack) window.mdlTrack(name, params); } catch (e) {}
    }

    /* ─── Regeln ─── */
    function pfadListe(text) {
      return String(text || '').split(/\r?\n/).map(function (z) { return z.trim(); }).filter(Boolean);
    }
    function pfadPasst(liste) {
      var p = window.location.pathname;
      return liste.some(function (eintrag) {
        if (eintrag.slice(-1) === '*') return p.indexOf(eintrag.slice(0, -1)) === 0;
        return p === eintrag || p === eintrag + '/' || p.indexOf(eintrag + '/') === 0;
      });
    }
    /* nie im Warenkorb, Konto, Checkout oder Bezahlvorgang (zusätzlich zur Prüfung in der Section) */
    var NIE = ['/cart', '/checkout', '/checkouts', '/account', '/customer_authentication', '/orders', '/pay'];
    function seiteErlaubt() {
      if (pfadPasst(NIE)) return false;
      var nur = pfadListe(C.nur);
      if (nur.length && !pfadPasst(nur)) return false;
      return !pfadPasst(pfadListe(C.ohne));
    }
    /* Hat sich diese Person auf dieser Seite schon angemeldet oder freigeschaltet? Dann nie ein Popup.
       mdl_kunde_angemeldet: jede Anmeldung über das Kundenformular (snippets/shopify-kunde-js, z. B.
       Forschungs-Check, Messe, Anleitung freischalten); mdl_freigeschaltet / mdl_nl_pending: Anleitung freischalten;
       mdl_hat_konto: war in diesem Browser schon einmal mit einem Kundenkonto eingeloggt (layout/theme.liquid) */
    function schonAngemeldet() {
      return !!(lies('localStorage', K.an) || lies('localStorage', 'mdl_kunde_angemeldet') || lies('localStorage', 'mdl_hat_konto') ||
        lies('localStorage', 'mdl_freigeschaltet') || lies('localStorage', 'mdl_nl_pending'));
    }
    function darf() {
      if (C.editor || test) return true;
      if (schonAngemeldet()) return false;
      var zu = parseInt(lies('localStorage', K.zu), 10) || 0;
      if (zu && Date.now() - zu < (C.tage || 7) * 864e5) return false;
      if (lies('sessionStorage', S.gezeigt)) return false;
      if ((parseInt(lies('sessionStorage', S.seiten), 10) || 0) < (C.minSeiten || 1)) return false;
      return seiteErlaubt();
    }
    /* anderes Fenster offen (Warenkorb, Menü, Newsletter-Popup)? Dann später nochmal versuchen */
    function andereOffen() {
      if (document.body && document.body.style.position === 'fixed') return true;
      /* nicht unterbrechen, während jemand in ein Feld tippt */
      var aktiv = document.activeElement;
      if (aktiv && !root.contains(aktiv) && /^(INPUT|TEXTAREA|SELECT)$/.test(aktiv.tagName)) return true;
      /* nicht mitten im Forschungs-Check (Fragen sichtbar) */
      var frage = document.querySelector('#modolino-quiz-root .mq-o, #modolino-quiz-root #mq-em');
      if (frage) {
        var fr = frage.getBoundingClientRect();
        if (fr.bottom > 0 && fr.top < window.innerHeight) return true;
      }
      var modale = document.querySelectorAll('[aria-modal="true"], dialog[open]');
      for (var i = 0; i < modale.length; i++) {
        var m = modale[i];
        if (m === box || root.contains(m) || m.offsetParent === null) continue;
        /* nur wirklich sichtbare Fenster zählen (der Warenkorb liegt z. B. versteckt neben dem Bildschirm) */
        var stil = window.getComputedStyle(m), r = m.getBoundingClientRect();
        if (stil.visibility === 'hidden' || parseFloat(stil.opacity) === 0) continue;
        if (r.width < 2 || r.height < 2 || r.right <= 0 || r.bottom <= 0 || r.left >= window.innerWidth || r.top >= window.innerHeight) continue;
        return true;
      }
      return false;
    }

    /* ─── Öffnen und Schließen ─── */
    function oeffnen(alsErfolg, ausloeser) {
      if (offen) return;
      offen = true;
      if (!alsErfolg && !C.editor) track('Popup_Angezeigt', { Quelle: ausloeser || 'unbekannt' });
      if (alsErfolg) zeigeErfolg(false);
      if (teaser) teaser.hidden = true;
      letzterFokus = document.activeElement;
      root.hidden = false;
      var balken = window.innerWidth - document.documentElement.clientWidth;
      if (balken > 0) document.documentElement.style.paddingRight = balken + 'px';
      document.documentElement.classList.add('eip-gesperrt');
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('eip--offen'); }); });
      /* Fokus in den Dialog. Am Computer direkt ins E-Mail-Feld (spart einen Klick),
         auf dem Handy nicht, damit die Tastatur nicht sofort aufklappt */
      setTimeout(function () {
        try {
          if (!istTouch && !alsErfolg && !(formteil && formteil.hidden)) (feldName || feldMail).focus({ preventScroll: true });
          else box.focus({ preventScroll: true });
        } catch (e) {}
      }, 360);
      if (!C.editor && !test) schreib('sessionStorage', S.gezeigt, '1');
    }
    function schliessen() {
      if (!offen) return;
      offen = false;
      if (!C.editor && !lies('localStorage', K.an)) track('Popup_Geschlossen', { Schritt: (formteil && formteil.hidden) ? 'Frage' : 'Formular' });
      root.classList.remove('eip--offen');
      setTimeout(function () { if (!offen) root.hidden = true; }, 260);
      document.documentElement.classList.remove('eip-gesperrt');
      document.documentElement.style.paddingRight = '';
      if (!C.editor && !test && !lies('localStorage', K.an)) {
        schreib('localStorage', K.zu, Date.now());
        teaserZeigen();
      }
      try { if (letzterFokus && letzterFokus.focus) letzterFokus.focus({ preventScroll: true }); } catch (e) {}
    }
    function ausloesen(grund) {
      if (ausgeloest || offen || !darf()) return;
      if (andereOffen()) { setTimeout(function () { ausloesen(grund); }, 4000); return; }
      ausgeloest = true;
      oeffnen(false, grund);
    }

    /* Schließen: X, „Nein danke“, „Schließen“ und jeder Klick außerhalb der Karte */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t === root || (t.closest && t.closest('[data-eip-zu]')) || (t.closest && !t.closest('.eip__box'))) {
        e.preventDefault(); schliessen();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (!offen) return;
      if (e.key === 'Escape') { schliessen(); return; }
      if (e.key !== 'Tab') return;
      /* Fokus im Dialog halten */
      var f = Array.prototype.filter.call(
        box.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!f.length) return;
      var erstes = f[0], letztes = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === erstes || document.activeElement === box)) { e.preventDefault(); letztes.focus(); }
      else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
    });

    /* ─── Teaser zum Wiederöffnen ─── */
    function teaserZeigen() {
      if (!teaser || !C.teaser || offen || lies('localStorage', K.teaserWeg) || schonAngemeldet() || !seiteErlaubt()) return;
      teaser.hidden = false;
      teaserAnheben();
    }
    /* feste Leisten unten (Kaufleiste auf Produktseiten, Warenkorb-Leiste) nicht überdecken */
    var anhebenGeplant = false;
    function teaserAnheben() {
      anhebenGeplant = false;
      if (!teaser || teaser.hidden) return;
      var abstand = 16;
      var leisten = document.querySelectorAll('.mpp-sticky, .mc-bar');
      for (var i = 0; i < leisten.length; i++) {
        var r = leisten[i].getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight && r.bottom > window.innerHeight - 4) {
          abstand = Math.max(abstand, window.innerHeight - r.top + 12);
        }
      }
      teaser.style.bottom = 'calc(' + Math.round(abstand) + 'px + env(safe-area-inset-bottom))';
    }
    function anhebenPlanen() { if (!anhebenGeplant) { anhebenGeplant = true; requestAnimationFrame(teaserAnheben); } }
    window.addEventListener('scroll', anhebenPlanen, { passive: true });
    window.addEventListener('resize', anhebenPlanen);
    if (teaser) {
      teaser.querySelector('.eip__teaser-auf').addEventListener('click', function () { oeffnen(false, 'Teaser'); });
      teaser.querySelector('.eip__teaser-weg').addEventListener('click', function () {
        teaser.hidden = true; schreib('localStorage', K.teaserWeg, '1');
      });
    }

    /* ─── Zweistufig: nach „Ja“ erscheint das E-Mail-Feld ─── */
    if (janein && formteil) {
      janein.querySelector('.eip__ja').addEventListener('click', function () {
        janein.hidden = true;
        formteil.hidden = false;
        track('Popup_Ja');
        setTimeout(function () { try { (feldName || feldMail).focus({ preventScroll: istTouch }); } catch (e) {} }, 60);
      });
    }

    /* ─── E-Mail immer ganz sichtbar: bei langen Adressen wird die Schrift im Feld kleiner ─── */
    var messen = null, MIN_PX = 6;
    function feldEinpassen() {
      var f = feldMail;
      f.style.fontSize = '';
      if (!f.value || f.clientWidth < 20) return;
      var cs = window.getComputedStyle(f);
      var basis = parseFloat(cs.fontSize);
      var platz = f.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 2;
      try {
        messen = messen || document.createElement('canvas').getContext('2d');
        messen.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + basis + 'px ' + cs.fontFamily;
        var breite = messen.measureText(f.value).width;
        if (breite > platz) f.style.fontSize = Math.max(MIN_PX, Math.floor(basis * platz / breite * 10) / 10) + 'px';
      } catch (e) {}
      /* Feinkorrektur an der tatsächlich gezeichneten Breite */
      var px = parseFloat(f.style.fontSize) || basis, n = 0;
      while (f.scrollWidth > f.clientWidth && px > MIN_PX && n++ < 40) { px = Math.max(MIN_PX, px - 0.25); f.style.fontSize = px + 'px'; }
    }
    ['input', 'change', 'blur'].forEach(function (ev) { feldMail.addEventListener(ev, feldEinpassen); });
    /* iPhone zoomt beim Antippen in Felder mit Schrift unter 16 px: beim Antippen kurz 16 px,
       danach wieder die kleine Schrift */
    feldMail.addEventListener('touchstart', function () { if (document.activeElement !== feldMail) feldMail.style.fontSize = '16px'; }, { passive: true });
    feldMail.addEventListener('focus', function () { setTimeout(feldEinpassen, istTouch ? 400 : 0); });
    window.addEventListener('resize', function () { if (offen) feldEinpassen(); });

    /* ─── Anmeldung ─── */
    function fehler(text, feld) {
      fehlerEl.textContent = text; fehlerEl.hidden = !text;
      [feldMail, feldName].forEach(function (f) { if (f) f.classList.toggle('eip__feld--fehler', f === feld); });
      if (feld) feld.focus();
    }
    function knopfFrei() { knopf.disabled = false; knopf.textContent = knopfText; }

    function konfetti() {
      if (!C.konfetti) return;
      var farben = ['#FF805A', '#81BC46', '#66C3FF', '#F7CA41', '#D8699C', '#6E64A5'];
      var huelle = document.createElement('div');
      huelle.className = 'eip__konfetti';
      for (var i = 0; i < 36; i++) {
        var t = document.createElement('i');
        t.style.left = (Math.random() * 100) + '%';
        t.style.background = farben[i % farben.length];
        t.style.animationDelay = (Math.random() * 0.35) + 's';
        t.style.transform = 'rotate(' + Math.round(Math.random() * 360) + 'deg)';
        huelle.appendChild(t);
      }
      box.appendChild(huelle);
      setTimeout(function () { if (huelle.parentNode) huelle.parentNode.removeChild(huelle); }, 2400);
    }

    function zeigeErfolg(mitKonfetti) {
      schreib('localStorage', K.an, Date.now());
      if (teaser) teaser.hidden = true;
      schrittForm.hidden = true;
      schrittOk.hidden = false;
      box.setAttribute('aria-labelledby', 'mdlEipTitelOk');
      if (mitKonfetti) konfetti();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var mail = feldMail.value.trim();
      var name = feldName ? feldName.value.trim() : '';
      if (feldName && C.name === 'pflicht' && !name) { fehler('Bitte gib deinen Vornamen ein.', feldName); return; }
      if (!EMAIL_RE.test(mail)) { fehler('Bitte gib eine gültige E-Mail-Adresse ein.', feldMail); return; }
      fehler('');
      if (typeof window.mdlKundeAnlegen !== 'function') { fehler('Das hat gerade nicht geklappt. Bitte lade die Seite neu.'); return; }
      track('Popup_Absenden');
      knopf.disabled = true; knopf.textContent = 'Einen Moment …';
      window.mdlKundeAnlegen(mail, C.tag || 'Exit Intent', MARKER, { ziel: captchaZiel, vorname: name })
        .then(function (ergebnis) {
          /* 'captcha': Formular wird normal abgeschickt, die Seite kommt mit ?popup=angemeldet zurück.
             Bricht jemand die Spam-Abfrage ab, bleibt die Seite stehen: Button dann wieder freigeben */
          if (ergebnis !== 'ok') { setTimeout(knopfFrei, 8000); return; }
          track('Newsletter_Anmeldung', { Quelle: 'Exit-Intent-Popup' });
          zeigeErfolg(true);
        })
        .catch(function (err) {
          knopfFrei();
          fehler((err && err.message) || 'Das hat gerade nicht geklappt. Bitte versuch es gleich noch einmal.');
        });
    });

    /* ─── Start ─── */
    if (window.mdlKundeMarker && window.mdlKundeMarker(MARKER)) {
      track('Newsletter_Anmeldung', { Quelle: 'Exit-Intent-Popup' });
      zeigeErfolg(false);
      oeffnen(true);
      setTimeout(konfetti, 350);
      return;
    }
    if (C.editor) { oeffnen(false, 'Editor'); return; }
    if (test) { setTimeout(function () { ausloesen('Test'); }, 800); return; }

    schreib('sessionStorage', S.seiten, (parseInt(lies('sessionStorage', S.seiten), 10) || 0) + 1);
    var teaserImmer = C.teaserImmer === 'immer';
    if (teaserImmer) teaserZeigen();
    if (!darf()) {
      var zu = lies('localStorage', K.zu);
      if (zu && !schonAngemeldet()) teaserZeigen();
      return;
    }

    /* Inaktivität (Computer und Handy): niemand scrollt, tippt oder bewegt die Maus */
    if (C.inaktiv > 0) {
      var ruheTimer = null;
      var ruheNeu = function () {
        clearTimeout(ruheTimer);
        if (!ausgeloest) ruheTimer = setTimeout(function () { ausloesen('Inaktiv'); }, C.inaktiv * 1000);
      };
      ['mousemove', 'scroll', 'keydown', 'touchstart', 'click'].forEach(function (ev) {
        window.addEventListener(ev, ruheNeu, { passive: true });
      });
      ruheNeu();
    }

    /* Bild vorladen, damit es beim Öffnen schon da ist */
    window.addEventListener('load', function () {
      setTimeout(function () {
        var img = root.querySelector('.eip__bild img');
        if (img) img.loading = 'eager';
      }, 2500);
    });

    var beginn = Date.now();

    if (!istTouch) {
      if (C.dExit) {
        document.addEventListener('mouseout', function (e) {
          if (e.relatedTarget || e.toElement) return;
          if (e.clientY > 8) return;
          if (Date.now() - beginn < (C.dDelay || 0) * 1000) return;
          ausloesen('Exit-Intent');
        });
      }
      if (C.dTimer > 0) setTimeout(function () { ausloesen('Zeit'); }, C.dTimer * 1000);
      return;
    }

    /* Handy und Tablet */
    var modus = C.mMode || 'eins';
    var zeitOk = !(C.mSek > 0), scrollOk = false;
    function pruefen() {
      var ok = modus === 'beide' ? (zeitOk && scrollOk)
        : modus === 'zeit' ? zeitOk
        : modus === 'scroll' ? scrollOk
        : (zeitOk || scrollOk);
      if (ok) ausloesen(scrollOk && !zeitOk ? 'Scrolltiefe' : 'Zeit');
    }
    if (C.mSek > 0) setTimeout(function () { zeitOk = true; pruefen(); }, C.mSek * 1000);
    /* Seite kaum scrollbar: Scrolltiefe gilt als erreicht, sobald die Seite geladen ist */
    window.addEventListener('load', function () {
      setTimeout(function () {
        var hoehe = document.documentElement.scrollHeight - window.innerHeight;
        if (hoehe < 120) { scrollOk = true; }
        pruefen();
      }, 1500);
    });
    if (document.readyState === 'complete') setTimeout(function () {
      if (document.documentElement.scrollHeight - window.innerHeight < 120) scrollOk = true;
      pruefen();
    }, 1500);

    var letztesY = window.scrollY, letzteZeit = Date.now(), tiefsterAnteil = 0;
    window.addEventListener('scroll', function () {
      var doc = document.documentElement;
      var hoehe = Math.max(1, doc.scrollHeight - window.innerHeight);
      var y = window.scrollY || doc.scrollTop || 0;
      var anteil = Math.min(100, (y / hoehe) * 100);
      if (anteil > tiefsterAnteil) tiefsterAnteil = anteil;
      if (!scrollOk && anteil >= (C.mScroll || 50)) { scrollOk = true; pruefen(); }
      /* schnelles Hochscrollen wirkt wie „Seite verlassen wollen“ */
      if (C.mHoch) {
        var jetzt = Date.now(), dt = jetzt - letzteZeit, dy = letztesY - y;
        if (dt > 0 && dt < 400 && dy > 120 && dy / dt > 1.2 && tiefsterAnteil > 25 && jetzt - beginn > 5000) ausloesen('Hochscrollen');
        letztesY = y; letzteZeit = jetzt;
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* Theme-Editor: Section wird bei jeder Änderung neu geladen */
  document.addEventListener('shopify:section:load', function () { setTimeout(start, 0); });
})();
